import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  Box,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles
} from '@material-ui/core'
import { Check, ChevronRight, MoreHoriz } from '@material-ui/icons'
import { getGoogleAttributeNameByLanguage } from '~/utils'
import { useLiterals } from '~/components/Literals'

const getAttibuteName = (AttributeObject, attributeName, lang) =>
  AttributeObject[getGoogleAttributeNameByLanguage(lang, attributeName)] ||
  AttributeObject[attributeName]

const countWords = (displayName) => displayName.split(' ').length

const useStyles = makeStyles((theme, context) => ({
  listItemIconRoot: {
    minWidth: 23
  },
  listItemRoot: {
    width: `initial`,
    paddingTop: 0,
    paddingBottom: 0
  },
  icon: {
    fontSize: '16px'
  }
}))

function GmbAttributesPreview({ handleOpen, isMobile, gmbAttributes }) {
  const config = useSelector((state) => state.config)
  const classes = useStyles({ isMobile: true })
  const { getLiteral } = useLiterals()

  // pega os três primeiros atributos booleanos positivos com a menor quantidade de pelavras.
  const attributes = useMemo(() => {
    return gmbAttributes
      .filter((attr) => attr.valueType === 'BOOL' && attr.values[0].value)
      .sort((a, b) => {
        a = countWords(getAttibuteName(a, 'displayName', config.language))
        b = countWords(getAttibuteName(b, 'displayName', config.language))

        return a - b
      })
      .splice(0, 3)
  }, [gmbAttributes])

  return (
    <Box
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'left',
        alignItems: 'center',
        gap: '0 16px',
        backgroundColor: '#F2F2F2',
        borderRadius: 4,
        padding: '8px 8px'
      }}
    >
      {attributes.map((attribute) => (
        <ListItem
          key={attribute.name}
          dense
          disableGutters
          classes={{ root: classes.listItemRoot }}
        >
          <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
            <Check fontSize="small" className={classes.icon} />
          </ListItemIcon>
          <ListItemText primary={getAttibuteName(attribute, 'displayName', config.language)} />
        </ListItem>
      ))}
      <ListItem
        key="vermais"
        dense
        disableGutters
        classes={{ root: classes.listItemRoot }}
        onClick={handleOpen}
        style={{ cursor: 'pointer' }}
      >
        <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
          <MoreHoriz fontSize="small" className={classes.icon} style={{ color: '#97A8AB' }} />
        </ListItemIcon>
        <ListItemText style={{ textDecoration: 'underline' }} primary={getLiteral('1513')} />
      </ListItem>
    </Box>
  )
}

export default GmbAttributesPreview
